module.exports = __webpack_public_path__ + "img/usa-flag.2a1d1b15.png";